class LocalStorageService {
  private store: any;
  private keyName: string;
  private static instance: LocalStorageService;
  private cachedStore: any;

  constructor() {
    this.store = this.getStore();
    this.keyName = '';
    this.cachedStore = {};
  }

  static getInstance() {
    if (!LocalStorageService.instance) {
      LocalStorageService.instance = new LocalStorageService();
    }

    return LocalStorageService.instance;
  }

  private getStore() {
    if (StoragePolyfill.isBrowserCapable()) {
      return localStorage;
    } else {
      return StoragePolyfill.getInstance();
    }
  }

  public select(selector: string): LocalStorageService {
    this.keyName = selector;

    return this;
  }

  public getJSON(key?: string): any {
    try {
      return JSON.parse(this.store.getItem(key || this.keyName)) || null;
    } catch (_error) {
      return null;
    }
  }

  public getCachedJSON(key: string): any {
    if (!this.cachedStore[key]) {
      this.cachedStore[key] = this.getJSON(key);
    }

    return this.cachedStore[key];
  }

  public set(data: any): void {
    this.store.setItem(this.keyName, JSON.stringify(data));
  }
}

class StoragePolyfill {
  private static _instance: StoragePolyfill = new StoragePolyfill();

  // @ts-ignore
  private static _capable: boolean = null;

  private _data: Object = {};

  constructor() {
    if (StoragePolyfill._instance) {
      throw new Error('Error: Instantiation failed: Use StoragePolyfill.getInstance() instead of new.');
    }
    StoragePolyfill._instance = this;
  }

  public static isBrowserCapable(): boolean {
    if (StoragePolyfill._capable !== null) {
      return StoragePolyfill._capable;
    }

    try {
      window.localStorage.setItem('testLocalStorage', '1');
      window.localStorage.removeItem('testLocalStorage');
      StoragePolyfill._capable = true;
    } catch (error) {
      StoragePolyfill._capable = false;
    }

    return StoragePolyfill._capable;
  }

  public static getInstance(): StoragePolyfill {
    return StoragePolyfill._instance;
  }

  // @ts-ignore
  public setItem(id, val) {
    // @ts-ignore
    return (this._data[id] = String(val));
  }

  // @ts-ignore
  public getItem(id) {
    // @ts-ignore
    return this._data.hasOwnProperty(id) ? this._data[id] : null;
  }
}

export default LocalStorageService;
